import { BlockAdapter } from 'modules/Cube/view/layouts/quote/QuoteEditorContent/ContentEditor/adapters/blocks/blockAdapter.types'

export const dividerAdapter: BlockAdapter<'divider'> = {
  in: () => {
    return [{ type: 'divider', props: {}, children: [] }]
  },
  out: () => () => {
    return {
      blockType: 'divider',
      config: {},
      version: 1
    }
  }
}
